import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { Can } from '@/features/acl/can';
import { DialogStateManager } from '@/features/dialog/dialog-provider';
import type { EventCreateDialogProps } from '@/features/events/components/event-create-dialog';
import { EventCreateDialog } from '@/features/events/components/event-create-dialog';
import { useLocale } from '@/lib/hooks/use-locale';
import type { CustomerBasics } from '@/server/types/infer-trpc-types';
import { CalendarIcon } from 'lucide-react';

type Props = {
    customer?: CustomerBasics;
    onCreated?: () => void;
    analyticsSource: EventCreateDialogProps['analyticsSource'];
};

export const DropdownMenuItemCreateEvent = ({ customer, onCreated, analyticsSource }: Props) => {
    const { t } = useLocale();

    const handleEventCreationClick = () => {
        void DialogStateManager.show(EventCreateDialog, {
            customer,
            onCreated,
            analyticsSource,
        } satisfies EventCreateDialogProps);
    };

    return (
        <Can I="create" a="CustomerEvent">
            <DropdownMenuItem onSelect={handleEventCreationClick}>
                <CalendarIcon className="h-4 w-4" />
                <span>{t('top_navbar__new_event')}</span>
            </DropdownMenuItem>
        </Can>
    );
};
